var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAlign48Filled = function SvgIconAlign48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.5v-13H6v13h2ZM17.885 9.5h-7.77C9.5 9.5 9 10.19 9 11.043v1.914c0 .852.5 1.543 1.115 1.543h7.77c.616 0 1.115-.69 1.115-1.543v-1.914c0-.852-.5-1.543-1.115-1.543Z",
    fill: "current"
  })));
};
export default SvgIconAlign48Filled;